export type BannerV3Type =
  | "BRAND"
  | "CAMPAIGN"
  | "CATEGORY"
  | "GIFTING_TEMPLATE";

interface BannerV3Base {
  id: number;
  name: string;
  imageUrl: string | null;
  desktopImageUrl: string | null;
}

export interface BrandBannerV3 extends BannerV3Base {
  type: "BRAND";
  brandKey: string;
  brandDiscountPercentage: number | null;
  overlaySvg?: string | null;
  desktopOverlaySvg?: string | null;
}

export interface CampaignBannerV3 extends BannerV3Base {
  type: "CAMPAIGN";
  externalLink: string | null;
}

export interface CategoryBannerV3 extends BannerV3Base {
  type: "CATEGORY";
  categoryName: string;
}

export interface GiftingTemplateBannerV3 extends BannerV3Base {
  type: "GIFTING_TEMPLATE";
  templateId: string;
  templateDiscountPercentage: number | null;
  overlaySvg?: string | null;
  desktopOverlaySvg?: string | null;
}

export type BannerV3 =
  | BrandBannerV3
  | CampaignBannerV3
  | CategoryBannerV3
  | GiftingTemplateBannerV3;

/** Banner types that carry an SVG overlay with a dynamic discount value. */
export type OverlayBannerV3 = BrandBannerV3 | GiftingTemplateBannerV3;

export function isOverlayBanner(banner: BannerV3): banner is OverlayBannerV3 {
  return banner.type === "BRAND" || banner.type === "GIFTING_TEMPLATE";
}

/** Discount value injected into the overlay SVG for BRAND / GIFTING_TEMPLATE banners. */
export function getOverlayDiscount(banner: OverlayBannerV3): number {
  return banner.type === "BRAND"
    ? banner.brandDiscountPercentage ?? 0
    : banner.templateDiscountPercentage ?? 0;
}
